'use client';

import { useState, useEffect } from 'react';

const FlyingBird = (): JSX.Element | null => {
  const [isVisible, setIsVisible] = useState(false);
  const [animationKey, setAnimationKey] = useState(0);

  useEffect(() => {
    const startAnimation = () => {
      setIsVisible(true);
      setAnimationKey(prev => prev + 1);
      
      // Hide bird after animation completes (8 seconds)
      setTimeout(() => {
        setIsVisible(false);
      }, 10000);
    };

    // Start first animation after 3 seconds to ensure page is loaded
    const initialTimeout = setTimeout(startAnimation, 3000);

    // Repeat every 12 seconds (10s animation + 2s gap)
    const interval = setInterval(startAnimation, 12000);

    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed top-0 left-0 w-full h-screen pointer-events-none z-[9999] overflow-hidden">
      <div
        key={animationKey}
        className="absolute top-20 w-32 h-32 animate-fly-across"
        style={{
          left: '-150px',
          animation: 'flyAcross 10s ease-in-out forwards'
        }}
      >
        {/* Flying bird with curved path */}
        <img 
          src="https://media.tenor.com/a_bwSoIpYBUAAAAi/bird.gif" 
          alt="Flying Bird" 
          className="w-full h-full object-contain drop-shadow-xl"
          style={{
            filter: 'drop-shadow(2px 2px 4px rgba(0,0,0,0.3))'
          }}
        />
      </div>
    </div>
  );
};

export default FlyingBird;